import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals } from '../../../../actions/modalActions';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import { A } from '../../../base/typography';
import LocationMapContainer from '../../../map/mapContainer';
import * as StyledModals from '../myShipmentsModals.styles';

interface Props {}

const ShowLocation: FC<Props> = () => {
	const dispatch = useDispatch<any>();
	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	const { modalLat, modalLng } = useSelector(({ modalReducer }) => modalReducer);

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div></div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>
			<StyledModals.MapContainer>
				<LocationMapContainer
					lat={modalLat}
					lng={modalLng}
					zoom={15}
					selectedMarker={null}
					onMarkerClick={() => {}}
					activeTab={-1}
				/>
			</StyledModals.MapContainer>
		</StyledModals.Wrapper>
	);
};

export default ShowLocation;
